import React, { useEffect, useState } from 'react';
import './Preloader.styles.scss';
import { AnimatePresence, motion } from 'framer-motion';

const Preloader = ({ data, onLoadComplete }) => {
	const [imagesProgress, setImagesProgress] = useState();
	const [loaded, setLoaded] = useState();

	const PreloadImage = (src, onProgress) => {
		return new Promise((resolve, reject) => {
			var xmlHTTP = new XMLHttpRequest();
			xmlHTTP.open('GET', src, true);
			xmlHTTP.responseType = 'arraybuffer';

			//const img = new Image();
			xmlHTTP.onload = resolve;
			xmlHTTP.onerror = reject;

			xmlHTTP.onprogress = (e) => {
				onProgress(parseInt((e.loaded / e.total) * 100));
			};
			xmlHTTP.send();
		});
	};

	const PreloadImages = (images, progressCallback) => {
		let totalToLoad = images.length;
		let totalData = data.length;

		return Promise.all(
			images.map((image) => {
				return PreloadImage(image, (imageProgress) => {
					progressCallback(imageProgress / totalToLoad);
				}).then((res) => {});
			})
		);
	};

	useEffect(() => {
		PreloadImages(data, (imagesProgress) => {
			setImagesProgress(imagesProgress);
		}).then(() => {
			setLoaded(true);
			onLoadComplete();
		});
	}, []);
	return (
		<>
			<AnimatePresence>
				{!loaded && (
					<motion.div className="mini-loader" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
						<div className="loader">
							<motion.div
								className="progress"
								initial={{ width: 0, opacity: 0 }}
								animate={{ opacity: 1, width: imagesProgress ? imagesProgress + '%' : '100%' }}
								exit={{ opacity: 0, width: '100%' }}
							></motion.div>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
};

export default Preloader;
